export default __webpack_public_path__ + "static/media/28.ab2050a9.png";